import { BellRing } from 'lucide-react';
import { LogAlertsConsole } from '@speles7172/log-console';
import '@speles7172/log-console/styles.css';
import { logAlertsTransport } from '../api/logAlerts';
import { useInTabbedPage } from '../components/common/TabbedPage';

/** A source as the console lists it: the function, without its log group and stage. */
export function shortLogSource(source: string): string {
  return source.replace(/^\/aws\/lambda\//, '').replace(/^peles-[^-]+-/, '');
}

/**
 * Log alerts and the daily log summary: rules over the application's own
 * logs, what they raised, and the morning email of errors and warnings.
 *
 * The whole screen is `<LogAlertsConsole>` from `@speles7172/log-console` —
 * the same deliberate exception as the Logs tab beside it: the rules, the AI
 * assistant, the test run and the summary preview are the package's, and the
 * server is log-client's alert engine (`/admin/log-alerts`), so merkos-managment
 * and this application run one implementation. Inside `.peles-controls` so it
 * takes the app's palette (`styles/controls-bridge.css`), on `theme="light"`
 * because the bridge, not the operating system, follows the app's dark mode.
 */
export function LogAlertsPage() {
  const embedded = useInTabbedPage();

  return (
    <div className="space-y-6">
      {!embedded && (
        <div className="flex items-center gap-3">
          <BellRing size={24} />
          <h1 className="text-2xl font-bold">Alerts</h1>
        </div>
      )}

      <div className="peles-controls">
        <LogAlertsConsole
          transport={logAlertsTransport}
          canManage
          title={null}
          theme="light"
          formatSource={shortLogSource}
          alertRecipients={
            <>
              the group routed to <strong>Log alert</strong> in Settings → Notifications (every
              administrator when none is), by email
            </>
          }
          summaryRecipients={
            <>
              the group routed to <strong>Daily log summary</strong> in Settings → Notifications
              (every administrator when none is)
            </>
          }
        />
      </div>
    </div>
  );
}
